import React from "react";

export default function ShareButton({ shareKey, label, icon: Icon, href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-ghost"
      aria-label={`Share on ${label}`}
      data-testid={`share-${shareKey}`}
    >
      <Icon size={14} />
      <span>{label}</span>
    </a>
  );
}
